// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".avatar-uploader .el-upload[data-v-0c8badf5]{border:1px dashed #d9d9d9;border-radius:6px;cursor:pointer;position:relative;overflow:hidden}.avatar-uploader .el-upload[data-v-0c8badf5]:hover{border-color:#409eff}.avatar-uploader-icon[data-v-0c8badf5]{font-size:28px;color:#8c939d;width:178px;height:178px;line-height:178px;text-align:center}.avatar[data-v-0c8badf5]{width:178px;height:178px;display:block}[data-v-0c8badf5] .el-input{width:80%}", ""]);
// Exports
module.exports = exports;
